import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

type SupportedLocale = 'en' | 'ru';

export type GameFont = 'montserrat' | 'inter' | 'roboto-mono' | 'lora' | 'space-grotesk' | 'dm-sans' | 'outfit';

export type GridStyle = 'bordered' | 'flat3d';

export interface OptionsState {
  darkMode: boolean;
  highContrast: boolean;
  cellMode3x3?: boolean;
  currentLocale: SupportedLocale;
  currentLocalization?: object;
  disableAnimation: boolean;
  disableSound: boolean;
  vibration: boolean;
  notifications: boolean;
  gameFont: GameFont;
  gridStyle: GridStyle;
}

const initialState: OptionsState = {
  darkMode: false,
  highContrast: false,
  cellMode3x3: false,
  currentLocale: 'en',
  currentLocalization: undefined,
  disableAnimation: false,
  disableSound: false,
  vibration: true,
  notifications: true,
  gameFont: 'inter',
  gridStyle: 'bordered',
};

export const optionsSlice = createSlice({
  name: 'options',
  initialState,
  reducers: {
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
    },
    setCurrentLocale: (state, action: PayloadAction<SupportedLocale>) => {
      state.currentLocale = action.payload;
    },
    setCurrentLocalization: (state, action: PayloadAction<object>) => {
      state.currentLocalization = action.payload;
    },
    setDisableAnimations: (state, action: PayloadAction<boolean>) => {
      state.disableAnimation = action.payload;
    },
    setDisableSound: (state, action: PayloadAction<boolean>) => {
      state.disableSound = action.payload;
    },
    setGameFont: (state, action: PayloadAction<GameFont>) => {
      state.gameFont = action.payload;
    },
    setHighContrast: (state, action: PayloadAction<boolean>) => {
      state.highContrast = action.payload;
    },
    setCellMode3x3: (state, action: PayloadAction<boolean>) => {
      state.cellMode3x3 = action.payload;
    },
    setGridStyle: (state, action: PayloadAction<GridStyle>) => {
      state.gridStyle = action.payload;
    },
    setVibration: (state, action: PayloadAction<boolean>) => {
      state.vibration = action.payload;
    },
    setNotifications: (state, action: PayloadAction<boolean>) => {
      state.notifications = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDisableSound,
  setDarkMode,
  setHighContrast,
  setCellMode3x3,
  setCurrentLocale,
  setCurrentLocalization,
  setDisableAnimations,
  setGameFont,
  setGridStyle,
  setVibration,
  setNotifications,
} = optionsSlice.actions;

export default optionsSlice.reducer;

export const darkMode = (state: RootState) => state.options.darkMode;

export const cellMode3x3 = (state: RootState) => state.options.cellMode3x3;
